import React, { useState, useEffect } from 'react';
import { KoModal, KoButton, KoForm,
  KoFormBuilder, KoEmpty, KoNano, KoToast, KoComments,
  KoTitle, KoDP, KoDateFormatter,
  KoLoader,
  KoRichTextEditor,
  KoText} from 'packages';
import KoIcon from '@kwapio/icons';
import styles from './curd.module.scss';
import { DevelopmentAPI } from '../development.service';
import { useDispatch } from 'react-redux';
import { getTicketTabCount } from 'shared/store/tickettabCountSlice';
import KoRichTextEditorReadOnly from 'packages/richText/richTextView';
export default function Comments({className,classNameMain, workspaceId, ticketId, setCreateComment, isOpenCommentsModal}) {
  const [commentsform] = KoForm.useForm();
  const [commentsList, setCommentsList] = useState();
  const [currentRecord, setCurrentRecord ] = useState();
  const [loading, setLoading] = useState(false);
  const [action, setaction] = useState(false);
  const [isOpenDelete, setDeleteModal] = useState(false);
  const [commentId, setCommentId] = useState(KoNano('COM'));
  const [attachmentsList, setAttachementsList] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    getComments(ticketId, workspaceId);
  }, []);

  const getComments = (ticketId, workspaceId) => {
    setLoading(true);
    DevelopmentAPI.getComments(ticketId, workspaceId).then(
      (data) => {
        setLoading(false);
        setCurrentRecord();
        dispatch(getTicketTabCount({ workspaceId: workspaceId, ticketId: ticketId }));
        
        setCommentsList(data?.comments);
      },
      (err) => {
        setLoading(false);
      }
    );

  };

  const createComment = (values, cmdId, isManul) => {
    setLoading(true);
    if(!cmdId && !currentRecord?.commentId){
      values['commentId'] = commentId;
      values['attachments'] = attachmentsList;
    }else{
      values['commentId'] = cmdId || currentRecord?.commentId;
      if(!isManul){
        values['attachments'] = [...attachmentsList, ...currentRecord?.attachments || values?.attachments];
      }
    }
    if(action === 'Reply'){
      values['parentCommentId'] = cmdId || currentRecord?.commentId;
      values['commentId'] = KoNano('COM');
    }
    values['ticketId'] = ticketId;
    DevelopmentAPI.createComment(values, action=== 'Reply' ? null : cmdId || currentRecord?.commentId, workspaceId).then(
      (res) => {
        commentsform.resetFields();
        DevelopmentAPI.getComments(ticketId, workspaceId).then(
          (res) => {
            if(action === 'Reply'){
              KoToast.success(`Comment Replied successfully`);
            }else{
              KoToast.success(`Comment ${cmdId || currentRecord?.commentId ? 'updated':'created'} successfully`);
            }
            setCommentId(KoNano('COM'));
            setCurrentRecord();
            setCreateComment(false);
            setLoading(false);
            getComments(ticketId, workspaceId);
          }
        );
      }
    );
  };

  const onUpdateAttachment=(att)=>{
    setAttachementsList(att);
  };

  const CommentsCriteria = ({ value, onChange }) =>
    <KoRichTextEditor initialValues={value} commentId={commentId} onUpdateAttachment={onUpdateAttachment}  lookupId={ticketId} workspaceId={workspaceId}  onSetEditorValues={v => onChange(v)}/>;
    


  
  const COMMENTSSECTION = {
    columns: 6,
    formItemLayout: null,
    colon: true,
    fields: [
      {
        key: 'content', placeholder: 'Comments', label: '', colSpan: 6,
        widget: CommentsCriteria
      }
    ]
  };

  const onReaction = (val, record) => {
    let obj = {
      reaction: val
    };
    DevelopmentAPI.createReaction(ticketId, record?.commentId, workspaceId, obj ).then(
      (res) => {
        getComments(ticketId, workspaceId);
      }
    );
    setCurrentRecord(record);
  };

  const onReply = (record) => {
    setCurrentRecord(record);
    setCreateComment(true);
    setaction('Reply');
  };

  const onDelete = (record) => {
    setCurrentRecord(record);
    setCommentId(record?.commentId);
    setDeleteModal(true);
  };

  const deleteComment = () => {
    setLoading(true);
    DevelopmentAPI.deleteComment(currentRecord?.ticketId, currentRecord?.commentId, workspaceId).then(
      (res) => {
        setLoading(false);
        KoToast.success(`Comment deleted successfully`);
        getComments(currentRecord?.ticketId, workspaceId);
        setDeleteModal(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const onUploadFiles = (record, files) => {
    let obj =  record;
    let att =[];
    for (let i = 0; i < files.length; i++) {
      att.push({
        ...files[i],
        url: files[i]?.response[0]
      });
    }
    obj['attachments'] = [...att, ...currentRecord?.attachments];
    createComment(obj, record?.commentId, true);
  };

  const onEdit = (record) => {
    setCurrentRecord(record);
    setCommentId(record?.commentId);
    setCreateComment(true);
    setaction('Edit');
  };

  // const enabledButtons = {
  //   color: true,
  //   backgroundColor: true,
  //   alignLeft: true,
  //   alignCenter: true,
  //   alignRight: true,
  //   alignJustify: true,
  //   blockquote: true,
  //   uploadImageButton: true,
  //   uploadVideoButton: true,
  //   codeBlock: true,
  //   link: true,
  //   insertEmbed: true
  // };

  return (
    <div className={`${styles.commentsSection} ${classNameMain || ''}`}>
      {loading &&  <KoLoader />}
      <div className={styles.headerTitle}>
        <KoTitle text={'Comments'} level={4} className={styles.title} />
        <KoButton type='primary' icon={<KoIcon color="#FFF" width={18} height={18} name={'PlusOutlined'} />} label={'Add a Comment'} onClick={() => setCreateComment(true)} />
      </div>
      {(!commentsList || commentsList?.length === 0) ?  <KoEmpty width={300} height={200} onClick={() => setCreateComment(true)} title={'Start a Conversation'}
        subText={''} label={'Add a Comment'}
        description={''}/> :
        <div className={styles.commentsList}>
          {/* <div className={styles.comments}>
            <KoForm form={commentsform} layout="vertical"
              onFinish={createComment} onSubmit={createComment}>
              <KoFormBuilder meta={COMMENTSSECTION} />
            </KoForm>
          </div>
          <div className={styles.saveCancel}>
            <KoButton key='cancel' label='Cancel' onClick={() => setCreateComment(false)} />
            <KoButton type='primary' key='Save'  label='Save' onClick={() => commentsform.submit()}/>
          </div> */}
          <KoComments className={className} workspaceId={workspaceId}  commentId={commentId} onUpdateAttachment={onUpdateAttachment} ticketId={ticketId}  lookupId={ticketId}
            data={commentsList} onReaction={onReaction}
            onReply={onReply} source='comments'  setComment={setCurrentRecord} onDelete={onDelete} onUploadFiles={onUploadFiles} onEdit={onEdit}/>
        </div>
      }
      <KoModal
        title={action ?  action + ' Comment' : 'Add a Comment'}
        centered
        open={isOpenCommentsModal}
        handleOk={() => { setCreateComment(false); }}
        onClose={() => { setCreateComment(false); }}
        width={`60vw`}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setCreateComment(false)} />,
          <KoButton type='primary' key='Save'  label={action &&  action !== 'Edit'?  action : 'Update'} onClick={() => commentsform.submit()}/>
        ]}>
        <div className={styles.mcomments}>
          {loading &&  <KoLoader />}
          {currentRecord && <div className={styles.replyComment}>
            <div className={styles.commentHeader}>
              <div className={styles.commentPic}>
                <KoDP width={35} height={35} logo={currentRecord?.profile?.logo} />
              </div>
              <div className={styles.commentName}>
                <KoTitle level={4} className={styles.name} text={currentRecord?.profile?.firstName} />
                <KoTitle level={4} className={styles.name}  text={currentRecord?.profile?.lastName} />
              </div>
              <div className={styles.dot}/>
              <KoDateFormatter data={currentRecord?.createdAt}  format={'DD-MMM-YYYY hh:mm a'}/>
            </div>
            <div className={styles.commentContent}>
              <KoRichTextEditorReadOnly initialValues={currentRecord?.content} />
            </div>
          </div>}
          <KoForm form={commentsform} layout="vertical"
            onFinish={createComment} onSubmit={createComment}>
            <KoFormBuilder meta={COMMENTSSECTION} />
          </KoForm>
        </div>
      </KoModal>

      <KoModal
        title={`Delete Comment`}
        centered
        open={isOpenDelete}
        afterClose={() => { setCurrentRecord(); }}
        handleOk={() => { setCurrentRecord(); setDeleteModal(false); }}
        onClose={() => { setCurrentRecord(); setDeleteModal(false); }}
        width={580}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(!isOpenDelete)} />,
          <KoButton key='delete' loading={loading} type='primary' label='Delete Comment' onClick={() => deleteComment()} />
        ]}
      >
        <div className={styles.wrapperModal}>
          <KoTitle level={5} text={`This action will delete item and cannot be undone`} />
          <KoText text={`Do you wish to proceed?`} />
        </div>
      </KoModal>
    
    </div>
  );
}
